import { render } from "./DesignModal.vue?vue&type=template&id=5eb671c0&ts=true"
import script from "./DesignModal.vue?vue&type=script&lang=ts"
export * from "./DesignModal.vue?vue&type=script&lang=ts"

import "./DesignModal.vue?vue&type=style&index=0&id=5eb671c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__